import React from 'react';
import { useMediaQuery } from 'react-responsive';
import FeaturesContent from './FeaturesContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <FeaturesContent history={history} />
  </Mobile>
);

export default MobileResponsive;
